export default __webpack_public_path__ + "img/d924f9b09fed376c69fa5ed455ffd9bc.svg";